<div class="row page-header">
    <div class="col-12">
        <h1>Damaged Utility Log <small>Log and track damaged utility lines</small></h1>
    </div>
</div>

<div [hidden]="isInitialLoading">
    <ul ngbNav [(activeId)]="activeTab" (activeIdChange)="tabChanged()" class="nav-tabs mb-3">
        @if (canViewDashboard) {
            <li [ngbNavItem]="0" [destroyOnHide]="false">
                <a ngbNavLink>Dashboard</a>
            </li>
        }
        <li [ngbNavItem]="1" [destroyOnHide]="false">
            <a ngbNavLink>Records</a>
        </li>
    </ul>

    @if (canViewDashboard) {
        <div [hidden]="!isDashboardTab">
            <app-damaged-utility-dashboard></app-damaged-utility-dashboard>
        </div>
    }

    <div [hidden]="!isRecordsTab">
        <app-damaged-utilities></app-damaged-utilities>
    </div>
</div>
